import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { getArticlesByCategory } from "@/utils/articles";

export default function CategoryGrid() {
  return (
    <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {categories.map((category) => (
        <Link
          key={category.slug}
          to={`/category/${category.slug}`}
          className="group relative h-[180px] md:h-[200px] rounded-lg overflow-hidden bg-foreground-950 cursor-pointer"
        >
          <img
            src={category.image}
            alt={category.name}
            title={`${category.name} - 黑料分类`}
            className="absolute inset-0 w-full h-full object-cover object-top opacity-70 transition duration-500 group-hover:opacity-90 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/50 to-transparent" />
          <div className="relative z-10 h-full flex flex-col justify-end p-4 text-background-50">
            <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center mb-2">
              <i className={`${category.icon} text-lg`} />
            </span>
            <h3 className="font-heading font-bold text-lg">{category.name}</h3>
            <p className="text-xs text-background-300/90 mt-1 line-clamp-2">{category.desc}</p>
            <span className="text-xs text-primary-300 mt-2 flex items-center gap-1">
              {getArticlesByCategory(category.slug).length} 篇内容
              <i className="ri-arrow-right-line transition group-hover:translate-x-1" />
            </span>
          </div>
        </Link>
      ))}
    </section>
  );
}